import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './HYBRID_Component_Mix.css';

const HYBRID_Component_Mix = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"HYBRID_COMPONENT_MIX",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	HYBRID_COMPONENT_MIX:-1
  });


  const [HYBRID_COMPONENT_MIX, setHYBRID_COMPONENT_MIX] = React.useState(null);
  const [HYBRID_COMPONENT_MIX_D, setHYBRID_COMPONENT_MIX_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Component Mix');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewHYBRID_COMPONENT_MIX(clientInfo,"OpenNew");

		navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutHYBRID_COMPONENT_MIX(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostHYBRID_COMPONENT_MIX(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewHYBRID_COMPONENT_MIX(clientInfo,"OpenNew");
		}
		navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
		if(Temp_Data2.status!="New"){
			handleDeleteHYBRID_COMPONENT_MIX(Temp_Data2);
			navigate('/HYBRID_Component_Mix#New',{replace:true});
		} 
		else 
			navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Component_Mix',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!HYBRID_COMPONENT_MIX) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_${i}_SECTION`;
	  const headerId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [HYBRID_COMPONENT_MIX]) ;


  
  
  var Ids = [];
  for(var Ele in HYBRID_COMPONENT_MIX){
	  for(var Sec in HYBRID_COMPONENT_MIX[Ele]){
		if(Sec == "id")
			Ids.push(HYBRID_COMPONENT_MIX[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(HYBRID_COMPONENT_MIX[Ele]["status"]);
		else if(Array.isArray(HYBRID_COMPONENT_MIX[Ele][Sec]))
			  for(var Row in HYBRID_COMPONENT_MIX[Ele][Sec])  // Convert to HYBRID_COMPONENT_MIX[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in HYBRID_COMPONENT_MIX[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["HYBRID_COMPONENT_MIX"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewHYBRID_COMPONENT_MIX(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX`).then((response1) => {
		if(!HYBRID_COMPONENT_MIX) 
			setHYBRID_COMPONENT_MIX(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX_D`).then((response2) => {
			setHYBRID_COMPONENT_MIX_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddHYBRID_COMPONENT_MIX_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewHYBRID_COMPONENT_MIX = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setHYBRID_COMPONENT_MIX(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataHYBRID_COMPONENT_MIX = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutHYBRID_COMPONENT_MIX = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostHYBRID_COMPONENT_MIX = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteHYBRID_COMPONENT_MIX = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMPONENT_MIX', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4"]=value;
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0"]=value;
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4"]=value;
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_COMPONENT_MIX(Temp_Data);
    setHYBRID_COMPONENT_MIX(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));  
  Temp_Data['2'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0"] = value;
  setHYBRID_COMPONENT_MIX(Temp_Data);
};


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));  
  Temp_Data['3'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0"] = value;
  setHYBRID_COMPONENT_MIX(Temp_Data);
};


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4"]=value;
    setHYBRID_COMPONENT_MIX(Temp_Data);
	//handleAddHYBRID_COMPONENT_MIX(Temp_Data,App_Data['HYBRID_COMPONENT_MIX']);
  }; 
  



 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!HYBRID_COMPONENT_MIX) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4']='';
	    break;
	  case('3'):
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4']='';
	    break;

  }


  const updatedHYBRID_COMPONENT_MIX =JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
  updatedHYBRID_COMPONENT_MIX[Sec] = [...updatedHYBRID_COMPONENT_MIX[Sec], newRow];
  setHYBRID_COMPONENT_MIX(updatedHYBRID_COMPONENT_MIX);
};

const handleDeleteRow = (sec,index) => {
  const updatedHYBRID_COMPONENT_MIX = JSON.parse(JSON.stringify(HYBRID_COMPONENT_MIX));
  updatedHYBRID_COMPONENT_MIX[sec].splice(index, 1);
  setHYBRID_COMPONENT_MIX(updatedHYBRID_COMPONENT_MIX);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Hybrid Component Mix`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Hybrid Component Mix ID`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Component Mix ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0" type="text" className="form-control" placeholder="HYBRID Component Mix ID" value={HYBRID_COMPONENT_MIX["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Component Mix ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1" type="text" className="form-control" placeholder="Offering ID" value={HYBRID_COMPONENT_MIX["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_HEADER">{t(`Hybrid Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Hybrid Component Type`)}</th>
                        <th>{t(`Rental Income Component Percentage`)}</th>
                        <th>{t(`Revenue Share Component Percentage`)}</th>
                        <th>{t(`Sale Profit Component Percentage`)}</th>
                        <th>{t(`Equity Appreciation Component Percentage`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_COMPONENT_MIX['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_0`]} name="Hybrid Component Type">
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Equity">Preferred Equity</option>
						  <option value="Debt Note">Debt Note</option>
						  <option value="Common Equity">Common Equity</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_1`]} placeholder="Rental Income Component Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_2`]} placeholder="Revenue Share Component Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_3`]} placeholder="Sale Profit Component Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_2_4`]} placeholder="Equity Appreciation Component Percentage"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_HEADER">{t(`Hybrid Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Hybrid Component Type`)}</th>
                        <th>{t(`Preferred Equity Component Percentage`)}</th>
                        <th>{t(`Debt Note Component Percentage`)}</th>
                        <th>{t(`Common Equity Component Percentage`)}</th>
                        <th>{t(`Component Total Percentage`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_COMPONENT_MIX['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_0`]} name="Hybrid Component Type">
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Equity">Preferred Equity</option>
						  <option value="Debt Note">Debt Note</option>
						  <option value="Common Equity">Common Equity</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_1`]} placeholder="Preferred Equity Component Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_2`]} placeholder="Debt Note Component Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_3`]} placeholder="Common Equity Component Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_3_4`]} placeholder="Component Total Percentage"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Hybrid Model Description`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Hybrid Model Description`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0" type="text" className="form-control" placeholder="Hybrid Model Description" value={HYBRID_COMPONENT_MIX["4"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4000ch' }}>
						 {t(`Enter Hybrid Model Description`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0" type="text" className="form-control" placeholder="Submitted By" value={HYBRID_COMPONENT_MIX["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1" type="text" className="form-control" placeholder="Submitted At" value={HYBRID_COMPONENT_MIX["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2" type="text" className="form-control" placeholder="Reviewed By" value={HYBRID_COMPONENT_MIX["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3" type="text" className="form-control" placeholder="Reviewed At" value={HYBRID_COMPONENT_MIX["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4"  value={HYBRID_COMPONENT_MIX["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5" type="text" className="form-control" placeholder="Approval Notes" value={HYBRID_COMPONENT_MIX["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0"  value={HYBRID_COMPONENT_MIX["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1" type="text" className="form-control" placeholder="Created By" value={HYBRID_COMPONENT_MIX["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2" type="text" className="form-control" placeholder="Created At" value={HYBRID_COMPONENT_MIX["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3" type="text" className="form-control" placeholder="Updated By" value={HYBRID_COMPONENT_MIX["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4" type="text" className="form-control" placeholder="Updated At" value={HYBRID_COMPONENT_MIX["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_COMPONENT_MIX_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default HYBRID_Component_Mix;  